import { render, staticRenderFns } from "./Up.vue?vue&type=template&id=728dcf78&scoped=true&"
import script from "./Up.vue?vue&type=script&lang=js&"
export * from "./Up.vue?vue&type=script&lang=js&"
import style0 from "./Up.vue?vue&type=style&index=0&id=728dcf78&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "728dcf78",
  null
  
)

export default component.exports